import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, documentTypes} from '../../util/uiconstants';
import {
	GetAllEngagementCommentsUrl,
	GetAllFormCommentsUrl,
	PatchDeleteFormCommentsUrl,
	CreateFormCommentsUrl
} from '../apiUrls';

export const getAllEngagementComments = (
	engagementId,
	parentEntityId,
	parentEntityUid,
	entityId,
	entityUid,
	showDeleted,
	isGuestUser,
	documentId,
	documentTypeId
) => {
	let isFormCommentToBeCalled = isGuestUser || documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL;
	const url = !isFormCommentToBeCalled
		? GetAllEngagementCommentsUrl(engagementId, {parentEntityId, parentEntityUid, entityId, entityUid, showDeleted})
		: GetAllFormCommentsUrl(engagementId, documentId, {
				parentEntityId,
				parentEntityUid,
				entityId,
				entityUid,
				showDeleted
		  });

	return {
		type: types.GET_ALL_ENGAGEMENT_COMMENTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const addToEngagementCommentsSlice = (comment) => {
	return {
		type: types.ADD_TO_ENGAGEMENT_COMMENT_SLICE,
		comment: comment
	};
};

export const setEngagementCommentsConfig = (config) => {
	return {
		type: types.SET_ENGAGEMENT_COMMENTS_CONFIG_DATA,
		config: config
	};
};

export const displayEngagementCommentInputModal = (modalConfiguration) => {
	return {
		type: types.DISPLAY_ENGAGEMENT_COMMENT_INPUT_MODAL,
		modalConfig: modalConfiguration
	};
};

export const setEngagementCommentsFilter = (filter) => {
	return {
		type: types.SET_ENGAGEMENT_COMMENTS_FILTER,
		filter: filter
	};
};

export const removeEngagementCommentsFilter = (filterType) => {
	return {
		type: types.REMOVE_ENGAGEMENT_COMMENTS_FILTER,
		filterType: filterType
	};
};

export const setSelectedEngagementCommentGuid = (guid) => {
	return {
		type: types.SET_SELECTED_ENGAGEMENT_COMMENT_GUID,
		guid: guid
	};
};

export const clearEngagementComments = (entityUid) => {
	return {
		type: types.CLEAR_ENGAGEMENT_COMMENTS,
		entityUid: entityUid
	};
};

function createEngagementComment(engagementId, data, actionType, isGuest, documentId, documentTypeId) {
	let isFormCommentToBeCalled = isGuest || documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL;
	let url = !isFormCommentToBeCalled
		? `${Env.getBaseURL(serviceURL, engagementId)}comments/`
		: CreateFormCommentsUrl(engagementId, documentId);

	return {
		type: actionType,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
}

function updateEngagementComment(
	engagementId,
	data,
	actionType,
	isGuest,
	documentId,
	documentTypeId,
	ignoreBodyUpdate
) {
	let isFormCommentToBeCalled = isGuest || documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL;
	let baseUrl = `${Env.getBaseURL(serviceURL, engagementId)}comments/${data.engagementCommentId}`;
	ignoreBodyUpdate === true ? (baseUrl += '?ignoreBodyUpdate=true') : '';
	const url = !isFormCommentToBeCalled
		? baseUrl
		: PatchDeleteFormCommentsUrl(engagementId, documentId, data.engagementCommentId);

	return {
		type: actionType,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}

function deleteEngagementComment(
	engagementId,
	engagementCommentGuid,
	parentEngagementCommentGuid,
	actionType,
	engagementCommentId,
	entityUid,
	isGuestUser,
	documentId,
	documentTypeId,
	ignoreBodyUpdate
) {
	let isFormCommentToBeCalled = isGuestUser || documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL;
	let baseUrl = `${Env.getBaseURL(serviceURL, engagementId)}comments/${engagementCommentId}`;
	ignoreBodyUpdate === true ? (baseUrl += '?ignoreBodyUpdate=true') : '';
	const url = !isFormCommentToBeCalled
		? baseUrl
		: PatchDeleteFormCommentsUrl(engagementId, documentId, engagementCommentId);

	return {
		type: actionType,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		parentEngagementCommentGuid: parentEngagementCommentGuid,
		engagementCommentGuid: engagementCommentGuid,
		entityUid: entityUid
	};
}

export function deleteEngagementCommentParent(
	engagementId,
	engagementCommentGuid,
	engagementCommentId,
	entityUid,
	isGuest,
	documentId,
	documentTypeId,
	ignoreBodyUpdate
) {
	return deleteEngagementComment(
		engagementId,
		engagementCommentGuid,
		engagementCommentGuid,
		types.DELETE_ENGAGEMENT_COMMENT_PARENT,
		engagementCommentId,
		entityUid,
		isGuest,
		documentId,
		documentTypeId,
		ignoreBodyUpdate
	);
}

export function deleteEngagementCommentChild(
	engagementId,
	engagementCommentGuid,
	parentEngagementCommentGuid,
	engagementCommentId,
	entityUid,
	isGuestUser,
	documentId,
	documentTypeId
) {
	return deleteEngagementComment(
		engagementId,
		engagementCommentGuid,
		parentEngagementCommentGuid,
		types.DELETE_ENGAGEMENT_COMMENT_CHILD,
		engagementCommentId,
		entityUid,
		isGuestUser,
		documentId,
		documentTypeId
	);
}

export function createEngagementCommentParent(engagementId, data, isGuest, documentId, documentTypeId) {
	return createEngagementComment(
		engagementId,
		data,
		types.CREATE_ENGAGEMENT_COMMENT,
		isGuest,
		documentId,
		documentTypeId
	);
}

export function createEngagementCommentReply(engagementId, data, isGuest, documentId, documentTypeId) {
	return createEngagementComment(
		engagementId,
		data,
		types.CREATE_ENGAGEMENT_COMMENT_REPLY,
		isGuest,
		documentId,
		documentTypeId
	);
}

export function updateEngagementCommentEntity(engagementId, data, isGuest, documentId, documentTypeId) {
	return updateEngagementComment(
		engagementId,
		data,
		types.UPDATE_ENGAGEMENT_COMMENT,
		isGuest,
		documentId,
		documentTypeId
	);
}

export function updateEngagementCommentStatus(engagementId, data, isGuest, documentId, documentTypeId, ignoreBodyType) {
	return updateEngagementComment(
		engagementId,
		data,
		types.UPDATE_ENGAGEMENT_COMMENT_STATUS,
		isGuest,
		documentId,
		documentTypeId,
		ignoreBodyType
	);
}

export function clearComments(engagementId, documentId, entityId, entityUId) {
	let url = `${Env.getBaseURL(serviceURL, engagementId)}comments/-1`;

	const data = {
		entityId: entityId,
		entityUid: entityUId,
		documentId: documentId,
		updateAction: 1
	};

	return {
		type: types.CLEAR_COMMENTS,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}

export const updateCommentCountAfterClearingComments = (bodyIds) => {
	return {
		type: types.UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS,
		bodyIds: bodyIds
	};
};
